export const CANCELLATION_POLICY_TITLE = 'Условия отмены этого тура';

export const CANCELLATION_POLICY_TOOLTIP_TEXT =
  'Сумма возврата рассчитывается исходя из условий туроператора и зависит от итоговой стоимости всего тура с учетом выбранного рейса и набора дополнительных услуг. В редких случаях условия возврата определяются туроператором в индивидуальном порядке.';
